<script setup>
import { onMounted, ref } from 'vue';
import { Carousel, Slide } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'
import { useFelixBagAuxStore } from '../../../store';


import ModalEscolha from './components/ModalEscolha.vue'

const felixBagAuxStore = useFelixBagAuxStore();

const openModal = ref(false)

const count = ref(0)
const carousel = ref(null)

onMounted(() => {
  felixBagAuxStore.pauseAfter(20000)
});

const profileOptions = [
  {
    name: 'gestante',
    title: 'Sou Gestante',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/4c7ac1c4-7ced-4298-8fe1-9f9681b9d3df.svg',
    text: "Parabéns pelo momento lindo!"
  },

  {
    name: 'fui_gestante',
    title: 'Fui Gestante e meu Bebê já nasceu',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/4fcf872c-8e84-450f-9a6b-22ba998bcdd2.svg',
    text: "Seu bebê já chegou? Que maravilha!"
  },

  {
    name: 'parceria',
    title: 'Sou parceria de gestante',
    img: "//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/7a162795-bcca-4fcd-9da1-3a78c76b3ce1.png",
    text: "Estaremos ao seu lado para te ajudar!"
  },

  {
    name: 'parceira_e_bebe_nasceu',
    title: 'Sou parceria e meu bebê já nasceu',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/ab9b9c87-194e-4b16-bae7-993b37cff4fa.svg',
    text: "Seu bebê já chegou? Que maravilha!"
  },

  {
    name: 'processo_adotivo',
    title: 'Estou em processo adotivo',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/8def483e-54f7-4cdd-ac76-e65fe20fb692.svg',
    text: "Parabéns por esta decisão!"
  },
]

function selectProfile(profile) {
  felixBagAuxStore.form.profile = profile;
  openModal.value = true;
}

</script>

<template>
  <div id="escolha-do-perfil">
    <Carousel ref="carousel" v-model="count" :items-to-show="1.4" style="margin-top: 150px;">
      <Slide v-for="profile in profileOptions" :key="profile.name">
        <div class="carousel-card">
          <img style="width: 90%;" :src="profile.img" alt="">
          <p style="height: 17%; width: 80%; margin-left: 10%; margin-top: 5%; color: #464646; font-weight: bold;">{{
            profile.title }}</p>
          <v-btn style="margin-top: 4%;" @click="selectProfile(profile)" color="#660099">Selecionar</v-btn>
        </div>
      </Slide>
    </Carousel>

    <v-btn @click="carousel.prev()" variant="plain" style="left: 15%" class="control-btns">
      <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/620306a3-1ad4-466a-b161-67dcbb72acec.svg" alt="">
    </v-btn>
    <div class="bullets">
      <div class="bullet-item" v-for="num in 5" :key="num" :class="count == num - 1 && 'active'"></div>
    </div>

    <v-btn @click="carousel.next()" variant="plain" style="right: 15%" class="control-btns"><img
        src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg"
        alt=""></v-btn>
  </div>



  <ModalEscolha :profile="felixBagAuxStore.form.profile" @close-modal="openModal = false"
    :show-modal="openModal" />
</template>

<style scoped>
#escolha-do-perfil {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}

.carousel-card {
  width: 250px;
  height: 280px;
  margin: 0 0 0 10%;
  background-color: #fff;
}

.control-btns {
  position: absolute;
  top: 80%;
  z-index: 2;
}


.bullets {
  width: 100%;
  height: 30px;
  position: absolute;
  top: 80.5%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bullet-item {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #E8E8E8;
  margin: 6px;
}

.bullet-item.active {
  background-color: #BC4AFF;
}
</style>